import { Routes } from '@angular/router';

export const adminContentRoutes: Routes = [
    {
        path: $localize`:@@adminContentPath:zawartosc`,
        loadComponent: () => import('src/app/rokezzz/blog/admin/views/blog/blog.component').then(module => module.RokezzzBlogViewComponent),
        data: {
            path: 'admin.content',
        },
        children: [
            {
                path: $localize`:@@adminContentHomePath:strona-glowna`,
                loadComponent: () => import('src/app/rokezzz/setting/views/setting/setting.component').then(module => module.RokezzzSettingViewComponent),
                data: {
                    title: $localize`Strona główna`,
                    settingGroup: 'home/',
                    path: 'admin.content.home',
                }
            },
            {
                path: $localize`:@@adminContentContactPath:kontakt`,
                loadComponent: () => import('src/app/rokezzz/setting/views/setting/setting.component').then(module => module.RokezzzSettingViewComponent),
                data: {
                    title: $localize`Kontakt`,
                    settingGroup: 'contact/',
                    path: 'admin.content.contact',
                }
            },
            {
                path: $localize`:@@adminContentPrivacyPolicyPath:polityka-prywatnosci`,
                loadComponent: () => import('src/app/rokezzz/setting/views/setting/setting.component').then(module => module.RokezzzSettingViewComponent),
                data: {
                    title: $localize`Polityka prywatności`,
                    settingGroup: 'policyPrivacy/',
                    path: 'admin.content.privacyPolicy',
                }
            },
            {
                path: $localize`:@@adminContentRegulationsPath:regulamin`,
                loadComponent: () => import('src/app/rokezzz/setting/views/setting/setting.component').then(module => module.RokezzzSettingViewComponent),
                data: {
                    title: $localize`Regulamin`,
                    settingGroup: 'regulations/',
                    path: 'admin.content.regulations',
                }
            },
        ]
    },
];
